import { Button as MuiButton, ButtonProps as MuiButtonProps } from '@mui/material';

interface ButtonProps extends MuiButtonProps {
  loading?: boolean;
}

export function Button({ loading, disabled, children, ...props }: ButtonProps) {
  return (
    <MuiButton
      {...props}
      disabled={disabled || loading}
      sx={{
        minHeight: 48,
        minWidth: 48,
        ...props.sx,
      }}
    >
      {loading ? 'Loading...' : children}
    </MuiButton>
  );
}
